<template>
    <div>
        <div class="dialogLeft">
            <div class="top">
                <div class="top_left">
                    <span>No.</span>
                    <div>B3</div>
                </div>
                <div class="top_right">B区3号楼</div>
            </div>
            <div class="bottom">
                <div class="table">
                    <div class="title">Name</div>
                    <div class="data">A# A07</div>
                </div>
                <div class="table">
                    <div class="title">id</div>
                    <div class="data">A# A07</div>
                </div>
                <div class="table">
                    <div class="title">code</div>
                    <div class="data">A# A07</div>
                </div>
                <div class="table">
                    <div class="title">data</div>
                    <div class="data">A# A07</div>
                </div>
            </div>

        </div>
        <div class="dialogRight"></div>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
.dialogLeft {
    border: 1px solid #f1802f;
    width: 374px;
    height: 245px;

    .top {
        padding-left: 15px;
        padding-top: 20px;
        color: #B4B6B7;
        display: flex;
        .top_left {
            display: flex;
            span{
                font-size: 14px;
                // border: 1px solid red;
                line-height: 20px;
                height: 20px;
                margin-top: 5px;
                margin-right: 8px;
            }
            div{
                font-size: 48px;
                font-weight: 500;
                height: 55px;
                line-height: 55px;
                color: #fff;
            }
        }
        .top_right{
            margin-top: 28px;
            margin-left: 35px;
        }
    }
    .bottom{
        // display: flex;
        margin-top: 22px;
        font-size: 18px;
        color: #fff;
        .table{
            margin-left: 24px;
            display: flex;
            .title{
                width: 84px;
                height: 26px;
                line-height: 26px;
                margin-bottom: 8px;
                margin-right: 12px;
            }
        }
    }
}
</style>